module.exports = "https://web-assets.ifttt.com/packs/media/partners/up_arrow-b9b7a30a.svg";